import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import createStore from "../../../shared/utils/createStore"
import MainView from './containers/MainView'
import { initHistoryState, updateOrderData, fetchOrderData, setIsWidgetView, setAsFinishedSuccessfully } from './actions'
import orderSelector from './selectors/orderSelector'
import rootReducer from './reducers'

$(document).ready(function() {
  $(".js-NewOrderView").each(function(i, element) {
    const appConfig = JSON.parse(element.getAttribute("data-app-config"))
    const productId = +element.getAttribute("data-product-id")
    const productVariantId = element.getAttribute("data-product-variant-id") ? +element.getAttribute("data-product-variant-id") : undefined;
    const productScheduleSlotId = element.getAttribute("data-product-schedule-slot-id") ? +element.getAttribute("data-product-schedule-slot-id") : undefined;
    const isWidgetView = !!element.getAttribute("data-is-widget-view")

    const store = st.NewOrderView.store = createStore(rootReducer)
    Object.defineProperty(st.NewOrderView, "state", { get: () => store.getState() })
    Object.defineProperty(st.NewOrderView, "order", { get: () => orderSelector(store.getState()) })
    window.app = st.NewOrderView

    store.dispatch(initHistoryState())
    store.dispatch(setIsWidgetView(isWidgetView))
    store.dispatch(updateOrderData({
      app_config: appConfig,
      affiliate_id: st.aid,
      customer_locale: st.locale,
      customer_currency: st.currency,
      product_id: productId,
      product_variant_id: productVariantId,
      product_schedule_slot_id: productScheduleSlotId,
      product_schedule_slot: undefined,
    }))

    render(
      <Provider store={store}>
        <MainView />
      </Provider>,
      element
    )
  })

  $(".js-existing-order-view").each(function(i, element) {
    const appConfig = JSON.parse(element.getAttribute("data-app-config"))
    const orderId = +element.getAttribute("data-order-id")
    const orderToken = element.getAttribute("data-order-token")
    const hasOrderPaymentFinished = element.getAttribute("data-order-has-payment-finished") === 'true';
    const hasOrderPaymentFailed = hasOrderPaymentFinished && element.getAttribute("data-order-has-payment-failed") === 'true';
    const hasOrderPaymentSucceeded = hasOrderPaymentFinished && !hasOrderPaymentFailed

    const store = st.NewOrderView.store = createStore(rootReducer)
    Object.defineProperty(st.NewOrderView, "state", { get: () => store.getState() })
    Object.defineProperty(st.NewOrderView, "order", { get: () => orderSelector(store.getState()) })
    window.app = st.NewOrderView

    store.dispatch(initHistoryState())
    store.dispatch(updateOrderData({
      app_config: appConfig,
      id: orderId,
      token: orderToken,
      _hasOrderJustFinished: hasOrderPaymentFinished,
      _hasPaymentFinished: hasOrderPaymentFinished,
      _hasPaymentSucceeded: hasOrderPaymentSucceeded,
      _hasPaymentFailed: hasOrderPaymentFailed,
    }))
    store.dispatch(fetchOrderData())

    render(
      <Provider store={store}>
        <MainView />
      </Provider>,
      element
    )
  })
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/init.jsx